import React, { useState, useRef } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Carousel, Row, Col } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import "../../../assets/styles/component/customer/itemDetail/VariantProductPage.scss";
import { useOutsideAlerter } from '../../../utils/CustomHooks';
import "../../../assets/styles/component/customer/itemDetail/SingleBannerPage.scss";
import { set_cart_items } from "../../../redux/actions/CartAction";
import { apiJson } from "../../../Api";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CartSidebar from "../cart/CartSidebar";

function VariantProductPage(props) {
  const { data, language } = props;

  const sideCartRef = useRef(null);
  let message = "";
  const { t } = useTranslation();
  const [showCart, setShowCart] = useState(false);
  useOutsideAlerter(sideCartRef, setShowCart);
  const [checkout_redirect, setCheckoutRedirect] = useState(false);

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const history = useHistory();

  if (!data?.variants || data.variants.length < 2) {
    return null;
  }

  const handleVariantClick = (variant) => {
    // Construct the URL similar to ItemCmp component
    const path = `/${props.countryUrl}-${language}/${data.category_title_en?.toLowerCase().replace(/ /g, "-")}/${data.slug}`;
    const search = `?sku=${encodeURIComponent(variant.sku)}`;
    history.push({ pathname: path, search: search });
  };

  const extractDescription = (htmlText) => {
    if (!htmlText) return "Varathane Premium Fast Dry Wood Stain is an oil-based, durable wood stain that provides a fast-drying finish for interior wood surfaces. This stain penetrates deeply into the wood grain to provide long-lasting protection and rich, even color.";
    const text = htmlText.replace(/<[^>]*>?/gm, '');
    const sentences = text.match(/[^.!?]+[.!?]+/g) || [];
    return sentences.slice(0, 5).join(' ').trim();
  };

  const getBannerData = () => {
    const title = data?.order_title || "Varathane Premium";
    const subtitle = data?.brand_name || "Fast Dry Wood Stain Cabernet";
    const description = extractDescription(data?.[`description_${language}`]);
    const variants = data?.variants || [];

    const getVariantImage = (variant) => {
      if (variant.featured_image) return variant.featured_image;
      if (variant.images && variant.images.length > 0) return variant.images[0];
      if (data.featured_image) return data.featured_image;
      if (data.images && data.images.length > 0) return data.images[0];
      return "path-to-fallback-image.png";
    };

    const enhancedVariants = variants.map(variant => ({
      ...variant,
      displayImage: getVariantImage(variant),
      variationText: language === 'ar' ? variant.variation_ar || variant.variation : variant.variation
    }));

    return {
      title: title,
      subtitle: subtitle,
      description: description,
      variants: enhancedVariants
    };
  };

  const banner = getBannerData();
  const variantCount = data.variants.length;

  const addToCartApiMethod = () => {
    // setAdding(true);
    apiJson.cart
      .addToCart(
        // props.data.product_type == "wholesale" ?
        //   {
        //     line_item: {
        //       quantity: parseInt(quantity.label ? quantity.label : quantity),
        //       orderable_type: "Variant",
        //       orderable_id: props.data.variantId,
        //       product_type: "wholesale"
        //     }
        //   }
        //   :
          // props.data.type === "Product"
          //   ? 
            {
              line_item: {
                quantity: 1,
                orderable_type: "Variant",
                orderable_id: props.data.order_id,
                is_assembly_added: false,
                // ...(addAssembly && { assembly_id: props.item.assembly.id })
              },
            }
            // : {
            //   line_item: {
            //     orderable_type: "Service",
            //     orderable_id: props.data.order_id,
            //     start_at: new Date(startDate).toString(),
            //     service_type: props.data?.service_type,
            //     ...(props.data?.service_type !== "one_time" && { end_at: new Date(endDate).toString() })
            //   },
            // },
        , props.countryId
      )
      .then((response) => {
        // setAdding(false);
        if (response.success) {
          if (
            localStorage.getItem("access_token") ||
            localStorage.getItem("user_key") === response.data.user_key
          ) {
            setShowCart(true);
          } else {
            localStorage.setItem("user_key", response.data.user_key);
            setShowCart(true);
          }
        } else if (!response.status) {
          message = t("errors.wrong");
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : t("errors.wrong");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      });
  }

  const buyNowApiMethod = () => {
    apiJson.cart
      .addToCart(
        // props.product?.product_type == "wholesale" ?
        //   {
        //     line_item: {
        //       quantity: parseInt(quantity.label ? quantity.label : quantity),
        //       orderable_type: "Variant",
        //       orderable_id: variant.id,
        //       product_type: "wholesale"
        //     }
        //   }
        //   :
        //   props.product?.type === "Product"
        //     ? 
            {
              line_item: {
                // quantity: parseInt(quantity.label ? quantity.label : quantity),
                quantity: 1,
                orderable_type: "Variant",
                orderable_id: props.data.order_id,
              },
            }
            // : {
            //   line_item: {
            //     orderable_type: "Service",
            //     orderable_id: props.product?.id,
            //     start_at: new Date(startDate).toString(),
            //     end_at: new Date(endDate).toString(),
            //   },
            // },
        , props.countryId
      )
      .then((response) => {
        if (response.success) {
          if (
            localStorage.getItem("access_token") ||
            localStorage.getItem("user_key") === response.data.user_key
          ) {
            // setShowCart(true);
          } else {
            localStorage.setItem("user_key", response.data.user_key);
            // setShowCart(true);
          }

          props.set_cart_items({ cart_items: response.data })

          // move to checkout
          if (props.auth) {
            apiJson
              .select.getDefault()
              .then(resp => {
                if (resp.success) {
                  if (resp.data.length > 0) {
                    const request = {
                      order: {
                        address_id: resp.data[0].id,
                        is_delivery: 1
                      },
                    };

                    apiJson.select
                      .varifyAdress(request, props.countryId)
                      .then((response) => {
                        if (response.success) {
                          props.set_cart_items({
                            order: {
                              address: resp.data[0],
                              id: response.data.id,
                              createdAddress: response.data,
                            },
                          });
                          setCheckoutRedirect({
                            value: true,
                            path:
                              "/" + props.countryUrl + "-" + props.language + "/checkout",
                          });
                        } else if (!response.status) {
                          message = t("errors.wrong");
                          showError();
                        } else {
                          if (response.status >= 400 && response.status < 500) {
                            message = response.message
                              ? response.message
                              : response.errors
                                ? response.errors
                                : t("errors.wrong");
                            showError();
                          } else {
                            message = response.message
                              ? response.message !== ""
                                ? response.message
                                : t("errors.wrong")
                              : t("errors.wrong");
                            showError();
                          }
                        }
                      });
                  }
                  else {
                    props.set_cart_items({
                      order: {
                        address: null,
                        id: null,
                        createdAddress: null,
                      },
                    });
                    setCheckoutRedirect({
                      value: true,
                      path:
                        "/" + props.countryUrl + "-" + props.language + "/checkout",
                    });
                  }
                }
              });
          }
          else {
            props.set_cart_items({
              order: {
                address: null,
                id: null,
                createdAddress: null,
              },
            });
            setCheckoutRedirect({
              value: true,
              path:
                "/" + props.countryUrl + "-" + props.language + "/checkout",
            });
          }
          // move to checkout end

        } else if (!response.status) {
          message = t("errors.wrong");
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : t("errors.wrong");
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : t("errors.wrong")
              : t("errors.wrong");
            showError();
          }
        }
      });
  }

  const renderVariantInfo = (variant) => (
    <div className="variant-info">
      <div className="variant-variation">{variant.variationText}</div>
      {variant.sku && <div className="variant-sku">SKU: {variant.sku}</div>}
      {variant.price && (
        <div className="variant-price">
          {data.currency} {variant.discounted_price || variant.price}
        </div>
      )}
    </div>
  );

  const renderImageGrid = () => (
    <Row className="g-3">
      {banner.variants.map((variant, index) => (
        <Col xs={6} key={`variant-${index}`}>
          <div 
            className="variant-image-container"
            onClick={() => handleVariantClick(variant)}
          >
            <div className="variant-image-wrapper">
              <img
                src={variant.displayImage}
                alt={`Variant ${index + 1}`}
                className="variant-image"
                onError={(e) => {
                  e.target.onerror = null; 
                  e.target.src = "path-to-fallback-image.png";
                }}
              />
            </div>
            <div className="variant-info-container">
              {renderVariantInfo(variant)}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );

  const renderCarousel = () => {
    const slides = [];
    const itemsPerSlide = 4;
    const fixedCarouselHeight = "460px";
    
    for (let i = 0; i < banner.variants.length; i += itemsPerSlide) {
      const slideVariants = banner.variants.slice(i, i + itemsPerSlide);
      
      slides.push(
        <Carousel.Item key={`slide-${i}`}>
          <div className="carousel-slide-container" style={{ height: fixedCarouselHeight }}>
            <Row className="g-3 h-100">
              {slideVariants.map((variant, j) => (
                <Col xs={6} key={`slide-item-${i}-${j}`} className="d-flex flex-column">
                  <div 
                    className="variant-image-container"
                    onClick={() => handleVariantClick(variant)}
                  >
                    <div className="variant-image-wrapper flex-grow-1">
                      <img
                        src={variant.displayImage}
                        alt={`Variant ${i + j + 1}`}
                        className="variant-image h-100"
                        style={{ objectFit: 'contain' }}
                        onError={(e) => {
                          e.target.onerror = null; 
                          e.target.src = "path-to-fallback-image.png";
                        }}
                      />
                    </div>
                    <div className="variant-info-container">
                      {renderVariantInfo(variant)}
                    </div>
                  </div>
                </Col>
              ))}
              {Array.from({ length: itemsPerSlide - slideVariants.length }).map((_, index) => (
                <Col xs={6} key={`empty-${index}`} className="d-flex flex-column">
                  <div className="variant-image-container">
                    <div className="variant-image-wrapper flex-grow-1 empty-slot"></div>
                    <div className="variant-info-container"></div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Carousel.Item>
      );
    }

    return (
      <div className="carousel-wrapper" style={{ height: fixedCarouselHeight }}>
        <Carousel 
          indicators={true}
          nextIcon={
            <div className="carousel-control-next-custom">
              <ChevronRight className="carousel-control-icon" />
            </div>
          }
          prevIcon={
            <div className="carousel-control-prev-custom">
              <ChevronLeft className="carousel-control-icon" />
            </div>
          }
        >
          {slides}
        </Carousel>
      </div>
    );
  };

  return (
    <div className="variant-product-page-wrapper">
      <div className="variant-product-container">
        <div className="product-info-container">
          <h1 className="product-title">{banner.title}</h1>
          <h2 className="product-subtitle">{banner.subtitle}</h2>
          <p className="product-description">{banner.description}</p>
          
          <div className="single-banner-buttons">
            <button
            onClick={addToCartApiMethod}
            className="view-more-button">Add to Cart</button>
            <button
             onClick={buyNowApiMethod}
             className="buy-now-button">Buy Now</button>
          </div>
        </div>

        <div className="variant-images-container">
          {variantCount <= 4 ? (
            renderImageGrid()
          ) : (
            renderCarousel()
          )}
        </div>
      </div>
      {showCart && <CartSidebar refs={sideCartRef} bool={showCart} />}
      {checkout_redirect.value && (
        <Redirect
          push
          to={{
            pathname: checkout_redirect.path,
            state: checkout_redirect.state,
          }}
        />
      )}
    </div>
  );
}

VariantProductPage.propTypes = {
  data: PropTypes.object,
  language: PropTypes.string,
  countryUrl: PropTypes.string
};

const mapStateToProps = (state) => ({
  language: state.language.language,
  countryUrl: state.language.countryUrl,
  countryId: state.language.countryId,
});

const mapDispatchToProps = { set_cart_items };

export default connect(mapStateToProps, mapDispatchToProps)(VariantProductPage);